export const settings = {
  title: "設定",
  notification: {
    title: "通知",
    inApp: "アプリ内通知",
    message: "メッセージ通知",
    updated: "通知設定を更新しました",
    error: "設定の更新に失敗しました",
    pushEnabled:
      "Push通知が有効なため、この画面での切り替えは表示していません。",
  },
  withdraw: {
    label: "退会",
    confirm: "退会しますか？",
    description:
      "退会するとアカウント情報がすべて削除されます。この操作は取り消せません。",
    execute: "退会する",
  },
} as const;
